const conditions = () => {
  return [{ projectType: { $ne: '' } }, { assetClass: { $in: ['object.asset-class.options.micro-und-serviced-living'] } }]
}

export default conditions
